export function isEmail(value) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || "").trim());
}

export function isRequired(value) {
  if (Array.isArray(value)) return value.length > 0;
  return String(value || "").trim().length > 0;
}

export function isPhone(value) {
  const digits = String(value || "").replace(/\D/g, "");
  return digits.length >= 10;
}

export function validateBuyerAccount(
  { name, email, phone, agent, broker, office, agentName, brokerName },
  options = {}
) {
  const errors = {};
  if (!isRequired(name)) errors.name = "Name is required";
  if (!isEmail(email)) errors.email = "Enter a valid email";
  if (phone && !isPhone(phone)) errors.phone = "Enter a valid phone number";
  if (options.linking !== false) {
    if (!isRequired(agent || agentName)) errors.agent = "Your agent is required";
    if (!isRequired(broker || brokerName)) errors.broker = "Your broker is required";
    if (!isRequired(office)) errors.office = "Office name is required";
  }
  return errors;
}

export function validateAgentAccount({ name, email, broker, office }) {
  const errors = {};
  if (!isRequired(name)) errors.name = "Name is required";
  if (!isEmail(email)) errors.email = "Enter a valid email";
  if (!isRequired(broker)) errors.broker = "Your broker is required";
  if (!isRequired(office)) errors.office = "Office name is required";
  return errors;
}

export function validateBrokerAccount({ name, email, office, tier }) {
  const errors = {};
  if (!isRequired(name)) errors.name = "Name is required";
  if (!isEmail(email)) errors.email = "Enter a valid email";
  if (!isRequired(office)) errors.office = "Office name is required";
  if (!isRequired(tier)) errors.tier = "Choose a seat plan";
  return errors;
}

export function validateSellerAccount({ name, email, phone, agent, broker, office }) {
  const errors = {};
  if (!isRequired(name)) errors.name = "Name is required";
  if (!isEmail(email)) errors.email = "Enter a valid email";
  if (phone && !isPhone(phone)) errors.phone = "Enter a valid phone number";
  if (!isRequired(agent)) errors.agent = "Your agent is required";
  if (!isRequired(broker)) errors.broker = "Your broker is required";
  if (!isRequired(office)) errors.office = "Office name is required";
  return errors;
}

export function validateLogin({ email, password }) {
  const errors = {};
  if (!isEmail(email)) errors.email = "Enter a valid email";
  if (!isRequired(password)) errors.password = "Password is required";
  return errors;
}
